require('../bootstrap');

import Vue from 'vue'

import './components';

new Vue({
    el: '#app',

    data() {
        return {
            loaded: false
        }
    },

    mounted() {        
        this.smoothScroll()
        
        setTimeout(() => { this.loaded = true }, 500)
    },

    methods: {
        smoothScroll() {
            $('a[href*="#"]')
                .not('[href="#"]')
                .not('[href="#home-carousel"]')
                .not('[href*="#collapse"]')
                .not('[href="#0"]')
                .click(function() {
                if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') || location.hostname == this.hostname) {

                    let target = $(this.hash);
                    // let headerHeight = document.getElementById('site-header').offsetHeight;

                    target = target.length ? target : $('[name=' + this.hash.slice(1) +']');

                    if (target.length) {

                        $('html,body').animate({
                            scrollTop: target.offset().top
                        }, 1000);
                        
                        return false;
                    }

                }
            });
        }
    }
})
